import { render } from "./SavingsDetails.vue?vue&type=template&id=664c8938&scoped=true"
import script from "./SavingsDetails.vue?vue&type=script&lang=js"
export * from "./SavingsDetails.vue?vue&type=script&lang=js"

import "./SavingsDetails.vue?vue&type=style&index=0&id=664c8938&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664c8938"]])

export default __exports__